<script>
  /** @type {{ stats: Array<{ value: number, label: string, href?: string }>, theme?: string }} */
  let { stats = [], theme = 'clean' } = $props()

  const isMinimal = $derived(theme === 'minimal')
  const isNeubrutalism = $derived(theme === 'neubrutalism')
  const isNature = $derived(theme === 'nature')
</script>

<div
  class="stats-row"
  class:stats-minimal={isMinimal}
  class:stats-brutal={isNeubrutalism}
  class:stats-nature={isNature}
>
  {#each stats as stat, i}
    {#if i > 0}
      <div class="stat-divider"></div>
    {/if}
    {#if stat.href}
      <a href={stat.href} class="stat-item stat-link">
        <span class="stat-value">{stat.value}</span>
        <span class="stat-label">{stat.label}</span>
      </a>
    {:else}
      <div class="stat-item">
        <span class="stat-value">{stat.value}</span>
        <span class="stat-label">{stat.label}</span>
      </div>
    {/if}
  {/each}
</div>

<style>
  .stats-row {
    display: inline-flex;
    align-items: center;
    gap: 20px;
    padding: 12px 24px;
    border-radius: var(--card-radius);
    background: var(--card-bg);
    border: 1px solid var(--card-border);
  }

  .stats-minimal {
    background: transparent;
    border: none;
    padding: 12px 0;
  }

  .stats-brutal {
    border: 3px solid var(--text-primary);
    box-shadow: 4px 4px 0px var(--text-primary);
    border-radius: 4px;
    background: var(--page-bg);
  }

  .stats-nature {
    border: 1px solid var(--card-border);
    border-radius: 24px;
    background: var(--card-bg);
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  .stat-value {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .stat-label {
    font-size: 12px;
    color: var(--text-secondary);
    font-weight: 400;
  }

  .stat-link {
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.15s;
  }

  .stat-link:hover {
    opacity: 0.7;
  }

  .stat-divider {
    width: 1px;
    height: 24px;
    background: var(--divider);
  }
</style>
